<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import FormattedContent from './Text/FormattedContent.vue';
import { useMessageContext } from '../provider.js';

const { content, additionalAttributes } = useMessageContext();

const templateParams = computed(
  () => additionalAttributes.value?.templateParams ?? null
);

const headerMedia = computed(() => {
  const h = templateParams.value?.processedParams?.header;
  return h?.mediaUrl ? h : null;
});

const buttons = computed(() => templateParams.value?.allButtons ?? []);

function buttonIcon(type) {
  switch (type?.toLowerCase()) {
    case 'url':
      return 'i-lucide-external-link';
    case 'phone_number':
      return 'i-lucide-phone';
    case 'copy_code':
      return 'i-lucide-copy';
    default:
      return 'i-lucide-corner-down-left';
  }
}
</script>

<template>
  <BaseBubble
    class="overflow-hidden min-w-[220px]"
    data-bubble-name="whatsapp-template"
  >
    <img
      v-if="headerMedia"
      :src="headerMedia.mediaUrl"
      class="w-full max-h-48 object-cover block -mx-0"
      alt=""
    />
    <div class="px-4 py-3">
      <FormattedContent v-if="content" :content="content" />
    </div>
    <template v-if="buttons.length">
      <div class="border-t border-n-weak" />
      <button
        v-for="(btn, i) in buttons"
        :key="i"
        type="button"
        class="w-full flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-n-blue-11 hover:bg-n-alpha-1 transition-colors"
        :class="i > 0 ? 'border-t border-n-weak' : ''"
      >
        <span class="size-3.5 shrink-0" :class="[buttonIcon(btn.type)]" />
        {{ btn.text }}
      </button>
    </template>
  </BaseBubble>
</template>
